module.exports = __webpack_public_path__ + "images/file_icons_v2/aspx-90e9673f4a1808ea29d6fd7295161d3e.svg";